import { useIsStudioWorkspace } from 'src/hooks/useIsStudioWorkspace';
import { useAppSelector } from 'src/hooks/useStore';
import { RootState } from 'src/store';
import { BannerOptions } from 'src/store/ui/types';

/**
 * Returns the current banner options from Redux, or undefined for Studio
 * workspaces where the trial banner should never be shown.
 */
export function useBannerOptions(): BannerOptions | undefined {
  const isStudio = useIsStudioWorkspace();
  const bannerOptions = useAppSelector(
    (state: RootState) => state.ui.bannerOptions,
  );
  return isStudio ? undefined : bannerOptions;
}
